export const token = ({ auth: { token } }) => token
export const userInfo = ({ auth: { userInfo } }) => userInfo
export const userId = (state) => userInfo(state)?.id
